'use strict';

// define 'app' namespace
if (!('app' in window)) window['app'] = {};

/***********************
 * Global onload event *
 ***********************/

$(function () {
    app.onloadEvents();
});

/***************************************
 * Global methods (in "app" namespace) *
 ***************************************/

app.responsiveImages = function () {
    let width = $(window).width();

    $('[data-js="responsiveImage"]').each(function () {
        let responsiveImage = app.determineResponsiveImageSize($(this), width);

        if ($(this).data('js-target') === 'img') {
            $(this).attr('src', responsiveImage);
        } else {
            $(this).css('background-image', 'url(' + responsiveImage + ')');
        }
    });
};

app.determineResponsiveImageSize = function ($responsiveImage, width = undefined) {
    if (width === undefined) {
        width = $(window).width();
    }

    var imageXL = $responsiveImage.data('image-xl'),
      imageMD = $responsiveImage.data('image-md'),
      imageXS = $responsiveImage.data('image-xs'),
      imageDefault = $responsiveImage.data('image'),
      responsiveImage = imageDefault;

    if ((width >= 1200) && (imageXL !== undefined)) {
        responsiveImage = imageXL;
    } else if ((width >= 768) && (imageMD !== undefined)) {
        responsiveImage = imageMD;
    } else if (imageXS !== undefined) {
        responsiveImage = imageXS;
    }

    // set the css with the correct image
    return responsiveImage;
};

app.onloadEvents = function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Accept-Language': $('html').attr('lang'),
            'X-Requested-With': 'XMLHttpRequest',
        },
    });

    // language switcher
    $('[data-js="switch-language"]').on('click', function () {
        // add current querystring to the href of the link (for example product filters may be present in the querystring)
        let queryString = decodeURIComponent(new URL(document.location).searchParams);
        let href = $(this).attr('href');
        let locale = $(this).data('locale');

        // set locale cookie (for cookie consent dialog to be shown in the correct language)
        document.cookie = 'locale=' + locale + '; expires=never; path=/';

        if (queryString !== '') {
            $(this).attr('href', href + '?' + queryString);
        }
    });

    // image slider
    if ($('.slick').is(':visible')) {
        $('.slick').slick({
            slidesToScroll: 3,
            slidesToShow: 3,
            swipeToSlide: false,
            dots: false,
            infinite: false,
            edgeFriction: true,
            prevArrow: false,
            nextArrow: false,
            variableWidth: true,
            focusOnSelect: false,
            swipe: false,
            touchMove: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 425,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        }).on('setPosition', function (event, slick) {
            var slickcardWidth = $('.slidecard').outerWidth(true);
            var slickcardLength = $(this).find('.slidecard').length;
            var slickTrackWidth = slickcardWidth * slickcardLength;

            $(this).find('.slick-track').css('width', slickTrackWidth);

            //This is because it didn't work with css on safari (ios)
            $('.slider-content .slidecard .slicecard-info .slide-title').css('text-overflow', 'ellipsis');
        });

        if ($('.download-slider').is(':visible')) {
            function sliderTitleHeight () {
                $('.download-slider').each(function () {
                    var min_highestBox = 0;
                    $('.slide-title', this).css('height', '');

                    $('.slide-title', this).each(function () {
                        if ($(this).height() > min_highestBox) {
                            min_highestBox = $(this).height();
                        }
                    });

                    $('.slide-title', this).height(min_highestBox);
                });
            }

            sliderTitleHeight();

            $('.download-slider .nav-item').on('click', function () {
                sliderTitleHeight();
            });
        }

        if ($('.related-product-slider').is(':visible')) {
            $('.related-product-slider').each(function () {
                var min_highestBox = 0;
                $('.slide-description.slicecard-info .product-title', this).each(function () {
                    if ($(this).height() > min_highestBox) {
                        min_highestBox = $(this).height();
                    }
                });

                $('.slide-description.slicecard-info .product-title', this).height(min_highestBox);
            });
        }

        if ($('.related-product-slider').is(':visible')) {
            $('.related-product-slider').each(function () {
                var min_highestBox = 0;
                $('.slide-description.slicecard-info .product-decription', this).each(function () {
                    if ($(this).height() > min_highestBox) {
                        min_highestBox = $(this).height();
                    }
                });

                $('.slide-description.slicecard-info .product-decription', this).height(min_highestBox);
            });
        }

        $('.slider-content').each(function () {
            var slideCardLength = $(this).find('.slick-list .slick-track').children().length;

            if (slideCardLength > 3) {
                $(this).addClass('slick-scrollbar');
            }
        });
    }

    //lazy loading
    let lazyImageElement = $('img.lazy');
    if (lazyImageElement.is(':visible')) {
        lazyImageElement.Lazy();
    }

    // Add class block-last
    $('.block-info').last().addClass('block-last');

    $('.container-slider .nav-link').on('click', function (e) {
        $('img.lazy').each(function () {
            var imgSrc = $(this).attr('data-src');
            $(this).attr('src', imgSrc).removeAttr('data-src');
        });
    });

    //slider desktop space
    function sliderDesktopSpace () {
        if (screen.width > 1088) {
            var bodyWidth = $('body').width(),
              containerWidth = $('.container.content').outerWidth(),
              sliderSpaceLeft = (bodyWidth - containerWidth) / 2,
              sliderWidth = bodyWidth - sliderSpaceLeft,
              sliderOurStore = sliderWidth - sliderSpaceLeft;

            if ($('.container-slider').is('#our_store')) {
                console.log('sliderOurStore = ' + sliderOurStore);
                $('.container-slider').css('width', sliderOurStore + 'px');
            } else {
                $('.container-slider').css('margin-left', sliderSpaceLeft + 'px').css('width', sliderWidth + 'px');
            }
        }
    }

    sliderDesktopSpace();

    //animations
    function bodyScrollSliderAnimation () {
        var lengthCollapseBtnToggle = $('#collapseBtnToggle').length;

        if (lengthCollapseBtnToggle < 1) {
            $('.slidecard-animation').each(function (i) {
                var a = $(this).offset().top - 400,
                  b = $(window).height(),
                  c = $(window).scrollTop();
                if ((b + c) > a) {
                    var slideCard = $(this);
                    setTimeout(function () {
                        slideCard.addClass('show-animation');
                    }, i * 50);
                }
            });
        } else {
            $('.slidecard-animation').each(function (i) {
                var slideCard = $(this);
                slideCard.addClass('show-animation');
            });
            $('img.lazy').each(function () {
                var imgSrc = $(this).attr('data-src');
                $(this).attr('src', imgSrc).removeAttr('data-src');
            });
        }
    }

    bodyScrollSliderAnimation();

    $(window).scroll(function () {
        bodyScrollSliderAnimation();
    });

    if ($('.related-product-slider').is(':visible')) {
        $('.related-product-slider').each(function () {
            var min_highestBox = 0;
            $('.slide-description.slicecard-info .slide-title', this).each(function () {
                if ($(this).height() > min_highestBox) {
                    min_highestBox = $(this).height();
                }
            });

            $('.slide-description.slicecard-info .slide-title', this).height(min_highestBox);
        });
    }

    if ($('.related-product-slider').is(':visible')) {
        $('.related-product-slider').each(function () {
            var min_highestBox = 0;
            $('.slide-description.slicecard-info .slide-subtext', this).each(function () {
                if ($(this).height() > min_highestBox) {
                    min_highestBox = $(this).height();
                }
            });

            $('.slide-description.slicecard-info .slide-subtext', this).height(min_highestBox);
        });
    }

    let disclaimerModal = $('div.disclaimer');
    if (disclaimerModal.length) {
        let postUrl = disclaimerModal.data('url');
        let disclaimerAcceptButton = $('.btn-approve-disclaimer');

        if (disclaimerAcceptButton.length) {
            disclaimerAcceptButton.on('click', function () {
                $.post(postUrl)
                  .done(function (response) {
                      if (response['success']) {
                          disclaimerModal.hide();
                      }
                  });
            });
        }
    }

    app.responsiveImages();

    $(window).on('resize', function () {
        app.responsiveImages();
    });

    // show modal for usa
    if ($('#modalRelatedLinks').length > 0) {
        $('#modalRelatedLinks').modal('show');
    }

    if ($('.type-content').length > 0) {
        $('table').not('.content-table').addClass('content-table').css('margin', 'initial');
    }

    $('.download-select-delegator').on('change', function (event) {
        let $this = $(event.target);
        if ($this.hasClass('grow-knowledge')) {
            window.open($this.val(), '_self');
            $this.prop('selectedIndex', 0);
        }
    });
};
